import { render, staticRenderFns } from "./ProcedureItemsComponent.vue?vue&type=template&id=70650968&scoped=true&"
import script from "./ProcedureItemsComponent.vue?vue&type=script&lang=ts&"
export * from "./ProcedureItemsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ProcedureItemsComponent.vue?vue&type=style&index=0&id=70650968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70650968",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VDivider,VList,VListItem,VListItemContent,VListItemIcon,VRow})
